import { render } from "./FontAwesome.vue?vue&type=template&id=2265f763"
import script from "./FontAwesome.vue?vue&type=script&lang=ts"
export * from "./FontAwesome.vue?vue&type=script&lang=ts"
script.render = render

export default script